export default "__VITE_ASSET__im4EWLzW__"